/*
 * ALL RIGHTS RESERVED,
 * (C) Hitachi, Ltd. 1995, 2016. All rights reserved.
 */

import { PjErrorInfo } from '../../extends_fw/service/PjErrorInfo';
import { PjBaseService } from '../../extends_fw/service/PjBaseService';
import { PjServiceResponse } from '../../extends_fw/service/PjServiceResponse';
import { AuthenticationService } from './AuthenticationService';

/**
 * ユーザの認証情報をチェックし、表示するテンプレートを選定する
 */
export class AuthenticationCheckService extends PjBaseService {

    /**
     * コンストラクタ
     * @param {any} $templateFactory テンプレートファクトリー
     * @param {ng.IWindowService} $window Windowサービス
     * @param {AuthenticationService} authenticationService ユーザ認証サービス
     */
    /* @ngInject */
    public constructor(
            protected $templateFactory: any,
            protected $window: ng.IWindowService,
            protected authenticationService: AuthenticationService) {
        super(null);
    }

    /**
     * 認証状態チェック
     * @param {string} templateUrl テンプレートURL
     * @return {ng.IPromise<string>} 画面に表示するテンプレートを返す。認証済み：パラメータのテンプレート、未認証：空文字
     */
    public isAuthenticated(
            templateUrl: string): ng.IPromise<string> {
        return this.authenticationService.isAuthenticated().then((res: PjServiceResponse<boolean>) => {
            if (res.data) {
                return this.$templateFactory.fromUrl(templateUrl);
            }
            this.$window.location.href = '../login/index.html#/';
            return '';
        })
        .catch((res: PjServiceResponse<boolean>) => {
            this.$window.location.href = '../login/index.html#/';
            return '';
        });
    }

}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/authentication/service/AuthenticationCheckService.ts
 **/